import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'

import type { CouponInfo } from '@entities/Loyalty'

import Button from '@shared/ui/button'
import { formatDate } from '@shared/uttils/formatDate'

import styles from './styles.module.scss'

interface CouponItemProps {
  coupon: CouponInfo;
}

export default function CouponItem ({ coupon }: CouponItemProps) {
  const isMobile = useMediaQuery('(max-width: 767px)')
  const { t: tn } = useTranslation('personal')
  const { t: tc } = useTranslation('common')

  const title = coupon.localInfo?.title || coupon.name || ''
  const description = coupon.localInfo?.description || ''
  const validTo = coupon.localInfo?.validTo || coupon.validTo
  const canBeActivated = coupon.localInfo?.canBeActivated ?? true

  return (
    <div className={styles.item}>
      <div className={styles.item__left}>
        <div className={styles.item__meta}>
          <div className={styles.item__tag}>{coupon.status}</div>
          {validTo && (
            <div className={styles.item__data}>
              {tc('up_to')} {formatDate(validTo)}
            </div>
          )}
        </div>
        <h4 className={styles.item__title}>{title}</h4>
        <p className={styles.item__description}>{description}</p>
        {canBeActivated && (
          <Button
            size={!isMobile ? 'large' : 'medium'}
            theme="white"
            className={styles.item__activity}
          >
            {tn('activate')}
          </Button>
        )}
      </div>
      <div className={styles.item__right}>
        {coupon.qrCode && (
          <Button theme="white" className={styles.item__qr}>
            <ReactSVG src="/icons/qrcode.svg" />
          </Button>
        )}
      </div>
    </div>
  )
}
